import React, { useState, useEffect } from "react";
import useStyles from "../style";
import useStylesTable from "../../settings/styles";
import { useHistory } from "react-router-dom";
import { useModal } from "../../../hooks/useModal";
import axios from "axios";
import config from "../../../config";
import useStylesTravelerSwitch from "../../user/styles";

// components
import InputComponent from "./inputComponent";
import InputSelect from "./inputSelect";
import InputSelectMembershipType from "./inputSelectMembershipType";
import { CircularProgress, Switch } from "@material-ui/core";
import InputDisableAge from "../../user/components/inputDisableAge";
import { TextField } from "@material-ui/core";
import SwitchPrincipalPartner from "../../user/components/switch";
import Modal from "../../modals/Modal";
//import ModalCamera from "../../modals/ModalCamera";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { RefreshRounded } from "@material-ui/icons";
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from "@material-ui/core/Checkbox";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell
} from "@material-ui/core";
import SimpleImageInput from "../../user/components/simpleImageInput";

const AddPartnerForm = ({ allGenders, allMembershipType, allPartnerType, allDays, costInscription, costTraveler, accessCountTraveler }) => {
  const expressions = {
    usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
    nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
    password: /^.{4,12}$/, // 4 a 12 digitos.
    email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
    numbers: /^[0-9]*$/, // 7 a 14 numeros.
    texto: /^[a-zA-Z0-9 ]{4,500}$/, // Letras
  }

  const classes = useStyles();
  const classesTable = useStylesTable();
  const classesTravelerSwitch = useStylesTravelerSwitch();
  let history = useHistory();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [name, setName] = useState({ text: '', valid: null });
  const [lastName, setLastName] = useState({ text: '', valid: null });
  const [birthdayDate, setBirthdayDate] = useState('');
  const [age, setAge] = useState('Edad');
  const [address, setAddress] = useState({ text: '', valid: null });
  const [image, setImage] = useState(null);
  const [fingerPrint, setFingerPrint] = useState({ text: '', valid: null });
  const [phone, setPhone] = useState({ text: '', valid: null });
  const [email, setEmail] = useState({ text: '', valid: null });
  const [gender, setGender] = useState({ text: '', valid: null });
  const [membershipType, setMembershipType] = useState({ text: '', membershipValidity: 0, cost: 0, services: [], valid: null });
  const [partnerType, setPartnerType] = useState({ text: '', valid: null });
  const [groupType, setGroupType] = useState({ text: '', numberOfPersons: 0, discount: 0, valid: null, isDiscountByPercent: false });
  const [autocompleteKey, setAutocompleteKey] = useState(0);
  const [membershipValidity, setMembershipValidity] = useState(0);
  const [allFingerPrints, setAllFingerPrints] = useState([]);
  const [paidInscription, setPaidInscription] = useState(false);
  const [isTraveler, setIsTraveler] = useState(false);
  const [principalImage, setPrincipalImage] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [isPricipalPartner, setIsPricipalPartner] = useState(true);
  const [partner, setPartner] = useState({ name: '', id: '', valid: null });
  const [showModal, setShowModal] = useState(false);
  //const [isOpenModalCamera, openModalCamera, closeModalCamera] = useModal(false);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    variant: "menu"
  };

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const fechFingerPrints = async () => {
    if (!showModal) {
      fetch(baseUrl + "getTemplates",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.error != null) {
            setShowModal(true);
          } else {
            setAllFingerPrints(data);
          }
        })
        .catch(error => null);
    }
  }

  const refreshToken = () => {
    setShowModal(true);
  }

  useEffect(() => {
    fechFingerPrints();
  }, []);

  const onChangeDatePicker = (e) => {
    setBirthdayDate(e.target.value);

    var today = new Date();
    var birthDate = new Date(e.target.value);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    setAge(age);
  }

  const onSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);

    if (name.valid === 'true' && lastName.valid === 'true' && membershipType.valid === 'true'
      && fingerPrint.valid === 'true') {
      var allList = "[";
      if (membershipType.services.length > 1) {

        for (var i = 0; i < membershipType.services.length; i++) {
          var item = membershipType.services[i];
          if (i == (membershipType.services.length - 1)) {
            allList = allList + "{serviceName: " + item.serviceName + ", numberOfDays: " + item.numberOfDays + ", days: [" + item.days + "]}]";
          } else {
            allList = allList + "{serviceName: " + item.serviceName + ", numberOfDays: " + item.numberOfDays + ", days: [" + item.days + "]}, ";
          }
        }
      } else {
        var item = membershipType.services[0];
        allList = "[{serviceName: " + item.serviceName + ", numberOfDays: " + item.numberOfDays + ", days: [" + item.days + "]}]";
      }

      const formData = new FormData();

      if (principalImage != null) formData.append("file", principalImage);
      formData.append("name", name.text);
      formData.append("lastName", lastName.text);
      formData.append("birthdayDate", birthdayDate);
      formData.append("age", age == 'Edad' ? 0 : age);
      formData.append("address", address.text);
      formData.append("email", email.text);
      formData.append("phone", phone.text);
      formData.append("membershipType", membershipType.text);
      formData.append("membershipValidity", membershipType.membershipValidity);
      formData.append("gender", gender.text);
      formData.append("fingerPrint", fingerPrint.text);
      formData.append("partnerType", partnerType.text);
      formData.append("groupType", groupType.text);
      formData.append("isPartnerPrincipal", isPricipalPartner ? 1 : 0);
      if (!isPricipalPartner) {
        formData.append("partnerPrincipalId", partner.id);
      }
      formData.append("accessCountMembership", Number(membershipType.membershipValidity));
      formData.append("accessCount", Number(membershipType.membershipValidity));
      formData.append("accessProId", 0);
      formData.append("isFree", membershipType.cost > 0 ? 0 : 1);
      formData.append("paidInscription", 0);
      formData.append("dayOfServices", allList);
      formData.append("isTraveler", isTraveler == true ? 1 : 0);

      axios({
        method: "post",
        url: baseUrl + "createPartner",
        data: formData,
        headers: { "Content-Type": "multipart/form-data", 'Authorization': localStorage.getItem("token") },
      })
        .then(function (response) {
          if (response.data.status == "Ok") {
            setName({ text: '', valid: null });
            setLastName({ text: '', valid: null });
            setBirthdayDate('');
            setAge('Edad');
            setAddress({ text: '', valid: null });
            setImage({ text: '', valid: '' });
            setFingerPrint({ text: '', valid: null });
            setPhone({ text: '', valid: null });
            setEmail({ text: '', valid: null });
            setGender({ text: '', valid: null });
            setMembershipType({ text: '', membershipValidity: 0, cost: 0, services: [], valid: null });
            setMembershipValidity(0);
            setPartnerType({ text: '', valid: null });
            setPartner({ name: '', id: '', valid: null });
            setGroupType({ text: '', numberOfPersons: 0, discount: 0, valid: null, isDiscountByPercent: false });
            setIsTraveler(false);
            setPrincipalImage(null);

            setAutocompleteKey(autocompleteKey + 1);
            fechFingerPrints();
          } else if (response.data.message == "Access is denied") {
            setShowModal(true);
          }
        })
        .catch(function (response) { });

      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }

  const onSubmitAndPay = async e => {
    e.preventDefault();
    setIsLoading(true);

    if (name.valid === 'true' && lastName.valid === 'true' && membershipType.valid === 'true'
      && fingerPrint.valid === 'true') {
      var allList = "";
      if (membershipType.services.length > 1) {

        for (var i = 0; i < membershipType.services.length; i++) {
          var item = membershipType.services[i];
          if (i == (membershipType.services.length - 1)) {
            allList = allList + "{serviceName: " + item.serviceName + ", numberOfDays: " + item.numberOfDays + ", days: [" + item.days + "]}";
          } else {
            allList = allList + "{serviceName: " + item.serviceName + ", numberOfDays: " + item.numberOfDays + ", days: [" + item.days + "]}, ";
          }
        }
      } else {
        var item = membershipType.services[0];
        allList = "[{serviceName: " + item.serviceName + ", numberOfDays: " + item.numberOfDays + ", days: [" + item.days + "]}]";
      }

      const formData = new FormData();

      formData.append("file", image);
      formData.append("name", name.text);
      formData.append("lastName", lastName.text);
      formData.append("birthdayDate", birthdayDate);
      formData.append("age", age == 'Edad' ? 0 : age);
      formData.append("address", address.text);
      formData.append("email", email.text);
      formData.append("phone", phone.text);
      formData.append("membershipType", membershipType.text);
      formData.append("membershipValidity", membershipType.membershipValidity);
      formData.append("gender", gender.text);
      formData.append("fingerPrint", fingerPrint.text);
      formData.append("partnerType", partnerType.text);
      formData.append("groupType", groupType.text);
      formData.append("isPartnerPrincipal", 1);
      formData.append("accessCountMembership", Number(membershipType.membershipValidity));
      formData.append("accessCount", Number(membershipType.membershipValidity));
      formData.append("accessProId", 0);
      formData.append("isFree", 0);
      formData.append("paidInscription", 0);
      formData.append("dayOfServices", allList);
      formData.append("isTraveler", isTraveler == true ? 1 : 0);

      axios({
        method: "post",
        url: baseUrl + "createPartner",
        data: formData,
        headers: { "Content-Type": "multipart/form-data", 'Authorization': localStorage.getItem("token") },
      })
        .then(function (response) {
          if (response.data.status == "Ok") {
            var total = 0.00;
            var subTotal = 0.00;

            if (isPricipalPartner) {
              if (groupType.isDiscountByPercent) {
                if (paidInscription) {
                  if (isTraveler) {
                    total = (membershipType.cost - (membershipType.cost * (groupType.discount)) / 100) + costInscription + costTraveler;
                    subTotal = membershipType.cost + costInscription;
                    localStorage.setItem("totalPay", total.toFixed(2));
                    localStorage.setItem("subtotal", subTotal.toFixed(2));
                  } else {
                    total = (membershipType.cost - (membershipType.cost * (groupType.discount)) / 100) + costInscription;
                    subTotal = membershipType.cost + costInscription;
                    localStorage.setItem("totalPay", total.toFixed(2));
                    localStorage.setItem("subtotal", subTotal.toFixed(2));
                  }
                } else {
                  if (isTraveler) {
                    total = (membershipType.cost - (membershipType.cost * (groupType.discount)) / 100) + costTraveler;
                    subTotal = membershipType.cost;
                    localStorage.setItem("totalPay", total.toFixed(2));
                    localStorage.setItem("subtotal", subTotal.toFixed(2));
                  } else {
                    total = membershipType.cost - (membershipType.cost * (groupType.discount)) / 100;
                    subTotal = membershipType.cost;
                    localStorage.setItem("totalPay", total.toFixed(2));
                    localStorage.setItem("subtotal", subTotal.toFixed(2));
                  }
                }
              } else {
                if (paidInscription) {
                  if (isTraveler) {
                    total = (membershipType.cost - groupType.discount) + costInscription + costTraveler;
                    subTotal = membershipType.cost + costInscription;
                    localStorage.setItem("totalPay", total.toFixed(2));
                    localStorage.setItem("subtotal", subTotal.toFixed(2));
                  } else {
                    total = (membershipType.cost - groupType.discount) + costInscription;
                    subTotal = membershipType.cost + costInscription;
                    localStorage.setItem("totalPay", total.toFixed(2));
                    localStorage.setItem("subtotal", subTotal.toFixed(2));
                  }
                } else {
                  if (isTraveler) {
                    total = (membershipType.cost - groupType.discount) + costTraveler;
                    subTotal = membershipType.cost;
                    localStorage.setItem("totalPay", total.toFixed(2));
                    localStorage.setItem("subtotal", subTotal.toFixed(2));
                  } else {
                    total = membershipType.cost - groupType.discount;
                    subTotal = membershipType.cost;
                    localStorage.setItem("totalPay", total.toFixed(2));
                    localStorage.setItem("subtotal", subTotal.toFixed(2));
                  }
                }
              }

              var discountPrice = 0.00;

              if (groupType.discount > 0) {
                if (groupType.isDiscountByPercent) {
                  discountPrice = (membershipType.cost * (groupType.discount)) / 100;
                  localStorage.setItem("discount", discountPrice.toFixed(2));
                } else {
                  discountPrice = groupType.discount;
                  localStorage.setItem("discount", discountPrice.toFixed(2));
                }
              } else {
                localStorage.setItem("discount", 0.00);
              }

              localStorage.setItem("groupType", groupType.text);
              localStorage.setItem("partnerId", response.data.content);
              localStorage.setItem('isForOneDay', false);

              history.push({
                pathname: '/app/payMembership',
                state: {
                  totalPay: total.toFixed(2), subtotal: subTotal.toFixed(2),
                  discount: discountPrice.toFixed(2), groupType: groupType.text, partnerId: response.data.content
                }
              });
            }

            setName({ text: '', valid: null });
            setLastName({ text: '', valid: null });
            setBirthdayDate('');
            setAge('Edad');
            setAddress({ text: '', valid: null });
            setImage({ text: '', valid: '' });
            setFingerPrint({ text: '', valid: null });
            setPhone({ text: '', valid: null });
            setEmail({ text: '', valid: null });
            setGender({ text: '', valid: null });
            setMembershipType({ text: '', membershipValidity: 0, cost: 0, services: [], valid: null });
            setMembershipValidity(0);
            setPartnerType({ text: '', valid: null });
            setPartner({ name: '', id: '', valid: null });
            setGroupType({ text: '', numberOfPersons: 0, discount: 0, valid: null, isDiscountByPercent: false });
            setIsTraveler(false);

            setAutocompleteKey(autocompleteKey + 1);
            fechFingerPrints();
          } else if (response.data.message == "Access is denied") {
            setShowModal(true);
          }
        })
        .catch(function (response) { });

      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }

  const onTagsChange = (event, values) => {
    if (values != null) {
      setFingerPrint({ text: values.template, valid: "true" });
    } else {
      setFingerPrint({ text: '', valid: "false" });
    }
  }

  const handleChangeDays = (property) => (e) => {
    const value = e.target.value;
    var serviceLessSevenDays = false;

    membershipType.services.map((item) => {
      if (item.serviceName == property) {
        if (item.numberOfDays < 7) {
          serviceLessSevenDays = true;
        }
      }
    });

    if (!serviceLessSevenDays) {
      if (value[value.length - 1] === "all") {
        const allDaysList = [];

        allDays.map((option) => {
          allDaysList.push(option.name);
        });

        membershipType.services.map((item) => {

          if (item.serviceName == property) {
            var index = membershipType.services.indexOf(item);

            var servicesItem = {
              "serviceName": item.serviceName,
              "numberOfDays": item.numberOfDays,
              "days": item.days.length === allDays.length ? [] : allDaysList,
              "isAllSelected": item.days.length === allDays.length ? false : true
            };

            const allList = membershipType.services;
            allList[index] = servicesItem;
            setMembershipType({ ...membershipType, services: allList });
          }
        });
        return;
      }
      if (value != '') {
        membershipType.services.map((item) => {
          if (item.serviceName == property) {
            const isAllSelected = allDays.length > 0 && item.days.length === allDays.length;
            var index = membershipType.services.indexOf(item);

            var servicesItem = {
              "serviceName": item.serviceName,
              "numberOfDays": item.numberOfDays,
              "days": value,
              "isAllSelected": isAllSelected
            };

            const allList = membershipType.services;
            allList[index] = servicesItem;
            setMembershipType({ ...membershipType, services: allList });
          }
        });
        return;
      }

      membershipType.services.map((item) => {
        if (item.serviceName == property) {
          const isAllSelected = allDays.length > 0 && item.days.length === allDays.length;
          var index = membershipType.services.indexOf(item);

          var servicesItem = {
            "serviceName": item.serviceName,
            "numberOfDays": item.numberOfDays,
            "days": value,
            "isAllSelected": isAllSelected
          };

          const allList = membershipType.services;
          allList[index] = servicesItem;
          setMembershipType({ ...membershipType, services: allList });
        }
      });
    } else {
      if (value[value.length - 1] === "all") {
        return;
      }
      if (value != '') {
        membershipType.services.map((item) => {
          if (item.serviceName == property) {
            const isAllSelected = allDays.length > 0 && item.days.length === allDays.length;
            var index = membershipType.services.indexOf(item);

            var servicesItem = {
              "serviceName": item.serviceName,
              "numberOfDays": item.numberOfDays,
              "days": value,
              "isAllSelected": isAllSelected
            };

            if (value.length <= item.numberOfDays) {
              const allList = membershipType.services;
              allList[index] = servicesItem;
              setMembershipType({ ...membershipType, services: allList });
            }
          }
        });
        return;
      }

      membershipType.services.map((item) => {
        if (item.serviceName == property) {
          const isAllSelected = allDays.length > 0 && item.days.length === allDays.length;
          var index = membershipType.services.indexOf(item);

          var servicesItem = {
            "serviceName": item.serviceName,
            "numberOfDays": item.numberOfDays,
            "days": value,
            "isAllSelected": isAllSelected
          };

          if (value.length <= item.numberOfDays) {
            const allList = membershipType.services;
            allList[index] = servicesItem;
            setMembershipType({ ...membershipType, services: allList });
          }
        }
      });
    }
  }

  const handleChangeTraveler = event => {
    var value = event.target.checked;

    setIsTraveler(value);
    if (value) {
      setMembershipType({ ...membershipType, membershipValidity: accessCountTraveler });
    } else {
      setMembershipType({ ...membershipType, membershipValidity: membershipValidity });
    }
  };

  return (
    <div>
      {showModal ? (
        <Modal
          isOpen={showModal}
          closeModal={closeModalLogin}
        />
      ) : (
        <></>
      )}

      <div className={classes.div} >
        <div className={classes.divTitle}>
          <label className={classes.titleStyle}>Agregar socio</label>
        </div>

        <div className={classes.divColumn} >
          <InputComponent
            text={name}
            setPartnerCode={setName}
            type="text"
            label="Nombres"
            name="name"
            regularExpression={expressions.nombre}
            placeholder="Nombre"
            isRequired={true}
          />

          <InputComponent
            text={lastName}
            setPartnerCode={setLastName}
            type="text"
            label="Apellidos"
            name="lastName"
            regularExpression={expressions.nombre}
            placeholder="Apellidos"
            isRequired={true}
          />

          <div className={classes.divDate}>
            <label className={classes.labelDate} >Fecha de nacimiento</label>
            <TextField
              type="date"
              defaultValue="2003-10-22"
              className={classes.inputDate}
              onChange={onChangeDatePicker}
              style={{ width: '85%' }}
              inputStyle={{ width: '85%' }}
            />
          </div>

          <InputDisableAge
            value={age}
            type="text"
            label="Edad"
            name="age"
            placeholder="18 años"
          />

          <SimpleImageInput
            text={principalImage}
            setValue={setPrincipalImage}
            label={"Foto del socio"}
          />

          <InputComponent
            text={address}
            setPartnerCode={setAddress}
            type="text"
            label="Dirección"
            name="address"
            regularExpression={expressions.texto}
            placeholder="Calle primera, 1234, Centro"
          />

          <InputComponent
            text={phone}
            setPartnerCode={setPhone}
            type="text"
            label="Teléfono"
            name="phone"
            regularExpression={expressions.numbers}
            placeholder="6688888888"
            isRequired={false}
          />

          <InputComponent
            text={email}
            setPartnerCode={setEmail}
            type="text"
            label="Correo electrónico"
            name="email"
            regularExpression={expressions.email}
            placeholder="correo@ejemplo.com"
            isRequired={false}
          />

          <InputSelect
            text={gender}
            setValue={setGender}
            label={"Género"}
            options={allGenders}
          />

          {/*<div>
            <label className={classes.label} >Foto del usuario</label>
            <button
              className={classes.enableButtonFinger}
              onClick={openModalCamera}>
              Tomar foto
            </button>
            <ModalCamera
              isOpen={isOpenModalCamera}
              closeModal={closeModalCamera}
              setPhoto={setImage}
            />
          </div>*/}

          <div>
            <div className={classes.divLabel}>
              <p className={classes.label} >Huella digital</p>
              <p style={{ fontSize: 26, color: "#FF0000" }}>*</p>
            </div>

            <div className={classes.divHeader} >
              <div className={classes.searchDivFullWidthWithoutShadow} >
                <Autocomplete
                  key={autocompleteKey}
                  options={allFingerPrints}
                  getOptionLabel={option => option.code}
                  onChange={onTagsChange}
                  className={classes.inputSearchFinger}
                  openText={"Abrir"}
                  closeText={"Cerrar"}
                  clearText={"Limpiar"}
                  noOptionsText={"Sin resultados"}
                  renderInput={params => (
                    <TextField
                      {...params}
                      variant="standard"
                      placeholder={"Buscar huella digital"}
                      fullWidth
                    />
                  )}
                />

                <div className={classes.divActionButton}>
                  <RefreshRounded className={classes.iconAcctionInventory}
                    onClick={fechFingerPrints}
                  />
                </div>
              </div>
            </div>
          </div>

          <InputSelectMembershipType
            text={membershipType}
            setValue={setMembershipType}
            setMembershipValidity={setMembershipValidity}
            label={"Tipo de membrecía"}
            options={allMembershipType}
            isRequired={true}
            allDays={allDays}
          />

          <div>
            <div className={classes.divLabel}>
              <p className={classes.label} >{"Días de acceso"}</p>
            </div>

            <div style={{ backgroundColor: "#FFFFFF", borderRadius: '4px', }}>
              <Table className="mb-0">
                <TableHead>
                  <TableRow className={classesTable.tableServices} >
                    <TableCell>SERVICIO</TableCell>
                    <TableCell>DÍAS SEMANA</TableCell>
                    <TableCell># DE DÍAS</TableCell>
                    {/*{keys.map(key => (
                            <TableCell key={key}>{key}</TableCell>
                        ))}*/}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {membershipType.services.map(({ serviceName, numberOfDays, days, isAllSelected }) => (
                    <TableRow>
                      <TableCell className={classesTable.tableServicesTextStyle} >{serviceName}</TableCell>

                      <TableCell className={classesTable.tableServicesTextStyle} >
                        <FormControl className={classes.formControl}>
                          {numberOfDays == 7 ? (
                            <>
                              <p style={{ color: "#000000" }}>L, M, M, J, V, S, D</p>
                            </>
                          ) : (
                            <>
                              <Select
                                labelId="mutiple-select-label"
                                multiple
                                value={days}
                                onChange={handleChangeDays(serviceName).bind(this)}
                                renderValue={(selected) => selected.join(", ")}
                                MenuProps={MenuProps}
                                style={{ color: "#000000" }}
                              >
                                <MenuItem
                                  value="all"
                                  classes={{
                                    root: isAllSelected ? classes.selectedAll : ""
                                  }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      classes={{ indeterminate: classes.indeterminateColor }}
                                      checked={isAllSelected}
                                      indeterminate={
                                        days.length > 0 && days.length <= allDays.length
                                      }
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    classes={{ primary: classes.selectAllText }}
                                    primary="Seleccionar todos"
                                  />
                                </MenuItem>
                                {allDays.map((option) => (
                                  <MenuItem key={option.name} value={option.name}>
                                    <ListItemIcon>
                                      <Checkbox checked={days.indexOf(option.name) > -1} />
                                    </ListItemIcon>
                                    <ListItemText primary={option.name} />
                                  </MenuItem>
                                ))}
                              </Select>
                            </>
                          )}
                        </FormControl>
                      </TableCell>

                      <TableCell className={classesTable.tableServicesTextStyle} >{numberOfDays + " días"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </div>

          <InputSelect
            text={partnerType}
            setValue={setPartnerType}
            label={"Tipo de socio"}
            options={allPartnerType}
            isRequired={false}
          />

          <div>
            <label className={classesTravelerSwitch.label} >{"¿Usuario viajero?"}</label>
            <div className={classesTravelerSwitch.divSwitch}>
              <p style={{ marginRight: "8px", fontSize: "16px", }}>No</p>
              <Switch
                checked={isTraveler}
                onChange={handleChangeTraveler}
                inputProps={{ "aria-label": "controlled" }}
              />
              <p style={{ marginLeft: "8px", fontSize: "16px", }}>Si</p>
            </div>
          </div>
        </div>

        <div className={classes.divColumn}>
          {groupType.discount > 0 && membershipType.text != '' ? (
            <>
              <div className={classes.divgroupTypeAndPrice}>
                <label className={classes.priceTitleStyle}>{"Precio: "}</label>
                {paidInscription ? (
                  <>
                    {isTraveler ? (
                      <label className={classes.priceTitleStyle}
                        style={{
                          textDecorationLine: 'line-through', fontWeight: '200',
                          fontSize: '20px', color: '#C9C9C9', marginLeft: '6px'
                        }}>{"$" + (membershipType.cost + costInscription + costTraveler)}</label>
                    ) : (
                      <label className={classes.priceTitleStyle}
                        style={{
                          textDecorationLine: 'line-through', fontWeight: '200',
                          fontSize: '20px', color: '#C9C9C9', marginLeft: '6px'
                        }}>{"$" + (membershipType.cost + costInscription)}</label>
                    )}
                  </>
                ) : (
                  <>
                    {isTraveler ? (
                      <label className={classes.priceTitleStyle}
                        style={{
                          textDecorationLine: 'line-through', fontWeight: '200',
                          fontSize: '20px', color: '#C9C9C9', marginLeft: '6px'
                        }}>{"$" + membershipType.cost + costTraveler}</label>
                    ) : (
                      <label className={classes.priceTitleStyle}
                        style={{
                          textDecorationLine: 'line-through', fontWeight: '200',
                          fontSize: '20px', color: '#C9C9C9', marginLeft: '6px'
                        }}>{"$" + membershipType.cost}</label>
                    )}
                  </>
                )}

                {groupType.isDiscountByPercent ? (
                  <>
                    {paidInscription ? (
                      <>
                        {isTraveler ? (
                          <label className={classes.priceTitleStyle}
                            style={{ marginLeft: '8px', color: '#3CD4A0' }}
                          >{"$" + ((membershipType.cost - (membershipType.cost * (groupType.discount)) / 100) + costInscription + costTraveler)}</label>
                        ) : (
                          <label className={classes.priceTitleStyle}
                            style={{ marginLeft: '8px', color: '#3CD4A0' }}
                          >{"$" + ((membershipType.cost - (membershipType.cost * (groupType.discount)) / 100) + costInscription)}</label>
                        )}
                      </>
                    ) : (
                      <>
                        {isTraveler ? (
                          <label className={classes.priceTitleStyle}
                            style={{ marginLeft: '8px', color: '#3CD4A0' }}
                          >{"$" + ((membershipType.cost - (membershipType.cost * (groupType.discount)) / 100) + costTraveler)}</label>
                        ) : (
                          <label className={classes.priceTitleStyle}
                            style={{ marginLeft: '8px', color: '#3CD4A0' }}
                          >{"$" + (membershipType.cost - (membershipType.cost * (groupType.discount)) / 100)}</label>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {paidInscription ? (
                      <>
                        {isTraveler ? (
                          <label className={classes.priceTitleStyle}
                            style={{ marginLeft: '8px', color: '#3CD4A0' }}
                          >{"$" + ((membershipType.cost - groupType.discount) + costInscription + costTraveler)}</label>
                        ) : (
                          <label className={classes.priceTitleStyle}
                            style={{ marginLeft: '8px', color: '#3CD4A0' }}
                          >{"$" + ((membershipType.cost - groupType.discount) + costInscription)}</label>
                        )}
                      </>
                    ) : (
                      <>
                        {isTraveler ? (
                          <label className={classes.priceTitleStyle}
                            style={{ marginLeft: '8px', color: '#3CD4A0' }}
                          >{"$" + ((membershipType.cost - groupType.discount) + costTraveler)}</label>
                        ) : (
                          <label className={classes.priceTitleStyle}
                            style={{ marginLeft: '8px', color: '#3CD4A0' }}
                          >{"$" + (membershipType.cost - groupType.discount)}</label>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              {membershipType.text != '' ? (
                <>
                  <div className={classes.divTitle}>
                    {groupType.isDiscountByPercent ? (
                      <>
                        {paidInscription ? (
                          <>
                            {isTraveler ? (
                              <label className={classes.priceTitleStyle}>{"Precio: $" + ((membershipType.cost - (membershipType.cost * (groupType.discount)) / 100) + costInscription + costTraveler)}</label>
                            ) : (
                              <label className={classes.priceTitleStyle}>{"Precio: $" + ((membershipType.cost - (membershipType.cost * (groupType.discount)) / 100) + costInscription)}</label>
                            )}
                          </>
                        ) : (
                          <>
                            {isTraveler ? (
                              <label className={classes.priceTitleStyle}>{"Precio: $" + ((membershipType.cost - (membershipType.cost * (groupType.discount)) / 100) + costTraveler)}</label>
                            ) : (
                              <label className={classes.priceTitleStyle}>{"Precio: $" + (membershipType.cost - (membershipType.cost * (groupType.discount)) / 100)}</label>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        {paidInscription ? (
                          <>
                            {isTraveler ? (
                              <label className={classes.priceTitleStyle}>{"Precio: $" + ((membershipType.cost - groupType.discount) + costInscription + costTraveler)}</label>
                            ) : (
                              <label className={classes.priceTitleStyle}>{"Precio: $" + ((membershipType.cost - groupType.discount) + costInscription)}</label>
                            )}
                          </>
                        ) : (
                          <>
                            {isTraveler ? (
                              <label className={classes.priceTitleStyle}>{"Precio: $" + ((membershipType.cost - groupType.discount) + costTraveler)}</label>
                            ) : (
                              <label className={classes.priceTitleStyle}>{"Precio: $" + (membershipType.cost - groupType.discount)}</label>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                </>
              ) : (
                <div className={classes.divTitle}>
                  <label className={classes.priceTitleStyle}>{"Precio: $0"}</label>
                </div>
              )}
            </>
          )}
        </div>

        <div className={classes.divButton}>
          {isLoading ? (
            <div className={classes.loginLoader} >
              <CircularProgress size={26} />
            </div>
          ) : (
            <>
              {!isPricipalPartner ? (
                <>
                  <button
                    className={name.valid === 'true' && lastName.valid === 'true'
                      && membershipType.valid === 'true' && partner.valid === 'true' ?
                      classes.enableButton : classes.disableButton}
                    disabled={!(name.valid === 'true' && lastName.valid === 'true'
                      && membershipType.valid === 'true' && partner.valid === 'true')}
                    onClick={onSubmit}
                  >Agregar</button>
                </>
              ) : (
                <>
                  <button
                    className={name.valid === 'true' && lastName.valid === 'true' && membershipType.valid === 'true'
                      && fingerPrint.valid === 'true' ?
                      classes.enableButton : classes.disableButton}
                    disabled={!(name.valid === 'true' && lastName.valid === 'true' && membershipType.valid === 'true'
                      && fingerPrint.valid === 'true')}
                    onClick={onSubmit}
                  >{isPricipalPartner ? "Agregar" : "Agregar  y Pagar"}</button>

                  {/*<button
                    className={name.valid === 'true' && lastName.valid === 'true' && membershipType.valid === 'true'
                      && fingerPrint.valid === 'true' ?
                      classes.enableButton : classes.disableButton}
                    disabled={!(name.valid === 'true' && lastName.valid === 'true' && membershipType.valid === 'true'
                      && fingerPrint.valid === 'true')}
                    onClick={onSubmitAndPay}
                  >{isPricipalPartner ? "Agregar y Pagar" : "Agregar"}</button>*/}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default AddPartnerForm;